import React from 'react';
import CloseIcon from '@material-ui/icons/Close';

class Step1 extends React.Component {

	//親コンポーネントを呼び出す
	changeSearchDomain(e) {
		this.props.updateSearchDomain(e.target.value);
	}

	//親コンポーネントを呼び出す
	handleCloseModal() {
		this.props.closeModal();
	}

	render() {

		//stepの初期化
		let modal = [];

		console.log(this.props.isDispModal)

		//モーダル表示フラグ
		if(this.props.isDispModal){
			modal.push(
				<div className="modal" style={{display: "block"}}>
					<div className="over-lay modal-close" onClick={() => { this.handleCloseModal(); }}></div>
					<div className="modal-inner" style={{width: "300px", animation: "0.3s ease 0s 1 normal forwards running modal"}} >
						<div className="modal-header">
							<span className="modal-title">エラー</span>
							<CloseIcon className="icon-close modal-close" style={{ fontSize: 19}} onClick={() => { this.handleCloseModal(); }}/>
						</div>
						<div className="modal-contents">{this.props.modalErrorMessage}</div>
						<button id="button-close" className="button modal-close" onClick={() => { this.handleCloseModal(); }}>OK</button>
					</div>
				</div>
			)
		}

		return (
			<div id="contents_body">
				<p>
					検索対象になるサイトのドメインを入力してください。
				</p>
				<form className="attention-box">
					<span>ドメイン</span>
					<input type="text" name="domeign" id="domeign" className="text-box" maxLength="100" placeholder="例）www.example.com" 
						value={this.props.searchdomain}
						onChange={(e) => { this.changeSearchDomain(e); }}
					/>
				</form>
				<p className="description">
					※検索対象にはドメインのみ指定できます。個別のページやディレクトリは指定できません。<br/>
					「http://www.○○○.com/web/index.html」というURLの場合、「www.○○○.com」の部分を入力してください。<br/>
					<br/>
					※複数のドメインを指定する場合は、カンマ区切りで「www.○○○.com,www.xxx.jp」のように指定してください。<br/>
				</p>
				{modal}
			</div>
		);
  	}
}

export default Step1;